import type { ReactNode } from 'react'
import styles from './ChipSelect.module.css'

export type ChipSelectOption = {
  id: string
  label: ReactNode
}

type ChipSelectProps = {
  ariaLabel?: string
  chipClassName?: string | undefined
  className?: string | undefined
  empty?: ReactNode
  onToggle: (id: string) => void
  options: ChipSelectOption[]
  selectedIds: string[]
}

export const ChipSelect = ({
  ariaLabel,
  chipClassName,
  className,
  empty,
  onToggle,
  options,
  selectedIds
}: ChipSelectProps) => (
  <div aria-label={ariaLabel} className={[styles.root, className].filter(Boolean).join(' ')}>
    {options.length === 0 && empty}
    {options.map((option) => {
      const selected = selectedIds.includes(option.id)

      return (
        <button
          className={[styles.chip, selected ? styles.selected : '', chipClassName].filter(Boolean).join(' ')}
          key={option.id}
          onClick={() => onToggle(option.id)}
          type="button"
        >
          {option.label}
        </button>
      )
    })}
  </div>
)
